import React from 'react'

const ChevronUp = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M12.003 10.688l-5.985 5.095c-.165.14-.385.217-.62.217-.234 0-.453-.077-.618-.217l-.524-.447C4.09 15.196 4 15.01 4 14.81s.09-.386.256-.526l7.126-6.066c.166-.14.386-.218.621-.217.236 0 .456.076.621.217l7.12 6.06c.165.14.256.327.256.527s-.09.386-.256.527l-.524.446c-.341.29-.897.29-1.238 0l-5.979-5.089z"/>
  </svg>
)

export default ChevronUp
